import axios from "axios";

class Users {
    create(user) {
        return axios.post('/api/v1/users', user);
    }

    getList() {
        return axios.get('/api/v1/users')
    }
}

export default Users